module.exports = __webpack_public_path__ + "img/Gambia.d9bd1071.svg";